export default "__VITE_ASSET__D0lHU7Py__"